import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'
import { NtakMainCategoryId } from '../ntak-main-category/NtakMainCategory'
import { SegmentId } from '../segment/Segment'

export enum NtakSubCategoryId {
  ACCOMMODATION_FEE = 1,
  TOURISM_TAX = 2,
  BATH_PROGRAM = 3,
  BEACH_PROGRAM = 4,
  SWIMMING_POOL_PROGRAM = 5,
  WELLNESS_PROGRAM = 6,
  HEALTHCARE_SERVICE = 7,
  OPEN_WATER_BEACH_PROGRAM = 8,
  EXHIBITION = 9,
  MUSEUM_EDUCATION = 10,
  GUIDED_TOUR_MUSEUM_CASTLE_PALACE = 11,
  VISIT_TO_CHURCH_FACILITY = 12,
  PALACE_VISIT = 13,
  CASTLE_VISIT = 14,
  OTHER_MONUMENT_VISIT = 15,
  EDUCATIONAL_PROGRAM_MUSEUM_CASTLE_PALACE = 16,
  LAKE_BOAT_CRUISE = 17,
  RIVER_BOAT_CRUISE = 18,
  HOP_ON_HOP_OFF_PROGRAM = 19,
  ADVENTURE_PARK_PROGRAM = 20,
  EXPERIENCE_CENTER_PROGRAM = 21,
  ZOO_PROGRAM = 22,
  WILDLIFE_PARK_PROGRAM = 23,
  AMUSEMENT_PARK_PROGRAM = 24,
  NATIONAL_PARK_VISIT = 25,
  HIKING_EXCURSIONS = 26,
  CULTURAL_EVENT = 27,
  CONCERT = 28,
  FESTIVAL = 29,
  BREAKFAST = 30,
  SANDWICH = 31,
  STARTER = 32,
  SOUP = 33,
  MAIN_COURSE = 34,
  SIDE_DISH = 35,
  PICKLES_SALAD = 36,
  TASTING_PORTION = 37,
  BAKERY_PRODUCTS = 38,
  DESSERT = 39,
  SNACK = 40,
  MAIN_COURSE_WITH_SIDE_DISH = 41,
  MEAL_PACKAGE = 42,
  WATER_LOCALLY_PREPARED = 43,
  LEMONADE_SYRUP_FRESH_JUICE = 44,
  NON_ALCOHOLIC_COCKTAIL = 45,
  TEA_HOT_CHOCOLATE_MILK_DRINKS = 46,
  SOFT_DRINK_LOCALLY_PREPARED_BEVERAGE_PACKAGE = 47,
  WATER_NOT_LOCALLY_PREPARED = 48,
  FRUIT_DRINK = 49,
  CARBONATED_DRINK = 50,
  NON_CARBONATED_DRINK = 51,
  COCKTAIL_MIXED_DRINK = 52,
  LIQUEUR = 53,
  SPIRIT = 54,
  BEER = 55,
  WINE = 56,
  SPARKLING_WINE = 57,
  ALCOHOLIC_BEVERAGE_PACKAGE = 58,
  OTHER = 59,
  SERVICE_CHARGE = 60,
  TIP = 61,
  OTHER_HOSPITALITY_SERVICES = 62,
  CAVE_VISIT = 63,
  GUIDED_TOUR_PROTECTED_NATURAL_AREA = 64,
  EDUCATIONAL_PROGRAM_PROTECTED_NATURAL_AREA = 65,
  PARK_VISIT = 66,
  THEMATIC_VISITOR_CENTRE_VISIT = 67,
  FOOD_OTHER = 68,
  COFFEE = 69,
  SOFT_DRINK_NOT_LOCALLY_PREPARED_BEVERAGE_PACKAGE = 70,
}

export class NtakSubCategory extends Codebook<NtakSubCategoryId> {
  static readonly ACCOMMODATION_FEE = new NtakSubCategory(
    NtakSubCategoryId.ACCOMMODATION_FEE,
    () => $t('Accommodation fee'),
    NtakMainCategoryId.ACCOMMODATION_FEE,
    [SegmentId.ACCOMMODATION, SegmentId.DISCOUNT_SURCHARGE],
  )

  static readonly TOURISM_TAX = new NtakSubCategory(
    NtakSubCategoryId.TOURISM_TAX,
    () => $t('Tourism tax'),
    NtakMainCategoryId.TOURISM_TAX,
    [SegmentId.CITY_FEES],
  )

  static readonly BATH_PROGRAM = new NtakSubCategory(
    NtakSubCategoryId.BATH_PROGRAM,
    () => $t('Bath program'),
    NtakMainCategoryId.PUBLIC_BATH,
    [],
  )

  static readonly BEACH_PROGRAM = new NtakSubCategory(
    NtakSubCategoryId.BEACH_PROGRAM,
    () => $t('Beach program'),
    NtakMainCategoryId.PUBLIC_BATH,
    [],
  )

  static readonly SWIMMING_POOL_PROGRAM = new NtakSubCategory(
    NtakSubCategoryId.SWIMMING_POOL_PROGRAM,
    () => $t('Swimming pool program'),
    NtakMainCategoryId.PUBLIC_BATH,
    [],
  )

  static readonly WELLNESS_PROGRAM = new NtakSubCategory(
    NtakSubCategoryId.WELLNESS_PROGRAM,
    () => $t('Wellness program'),
    NtakMainCategoryId.PUBLIC_BATH,
    [SegmentId.MASSAGES, SegmentId.SAUNA, SegmentId.WELLNESS, SegmentId.COSMETICS],
  )

  static readonly HEALTHCARE_SERVICE = new NtakSubCategory(
    NtakSubCategoryId.HEALTHCARE_SERVICE,
    () => $t('Healthcare service'),
    NtakMainCategoryId.PUBLIC_BATH,
    [SegmentId.HEALING, SegmentId.BALNEO],
  )

  static readonly OPEN_WATER_BEACH_PROGRAM = new NtakSubCategory(
    NtakSubCategoryId.OPEN_WATER_BEACH_PROGRAM,
    () => $t('Open-water beach program'),
    NtakMainCategoryId.NATURAL_BATHING_AREA,
    [],
  )

  static readonly EXHIBITION = new NtakSubCategory(
    NtakSubCategoryId.EXHIBITION,
    () => $t('Exhibition'),
    NtakMainCategoryId.MUSEUM_CASTLE_PALACE,
    [],
  )

  static readonly MUSEUM_EDUCATION = new NtakSubCategory(
    NtakSubCategoryId.MUSEUM_EDUCATION,
    () => $t('Museum education'),
    NtakMainCategoryId.MUSEUM_CASTLE_PALACE,
    [],
  )

  static readonly GUIDED_TOUR_MUSEUM_CASTLE_PALACE = new NtakSubCategory(
    NtakSubCategoryId.GUIDED_TOUR_MUSEUM_CASTLE_PALACE,
    () => $t('Guided tour (museum, castle, palace)'),
    NtakMainCategoryId.MUSEUM_CASTLE_PALACE,
    [],
  )

  static readonly VISIT_TO_CHURCH_FACILITY = new NtakSubCategory(
    NtakSubCategoryId.VISIT_TO_CHURCH_FACILITY,
    () => $t('Visit to church facility'),
    NtakMainCategoryId.MUSEUM_CASTLE_PALACE,
    [],
  )

  static readonly PALACE_VISIT = new NtakSubCategory(
    NtakSubCategoryId.PALACE_VISIT,
    () => $t('Palace visit'),
    NtakMainCategoryId.MUSEUM_CASTLE_PALACE,
    [],
  )

  static readonly CASTLE_VISIT = new NtakSubCategory(
    NtakSubCategoryId.CASTLE_VISIT,
    () => $t('Castle visit'),
    NtakMainCategoryId.MUSEUM_CASTLE_PALACE,
    [],
  )

  static readonly OTHER_MONUMENT_VISIT = new NtakSubCategory(
    NtakSubCategoryId.OTHER_MONUMENT_VISIT,
    () => $t('Other monument visit'),
    NtakMainCategoryId.MUSEUM_CASTLE_PALACE,
    [],
  )

  static readonly EDUCATIONAL_PROGRAM_MUSEUM_CASTLE_PALACE = new NtakSubCategory(
    NtakSubCategoryId.EDUCATIONAL_PROGRAM_MUSEUM_CASTLE_PALACE,
    () => $t('Educational program (museum, castle, palace)'),
    NtakMainCategoryId.MUSEUM_CASTLE_PALACE,
    [],
  )

  static readonly LAKE_BOAT_CRUISE = new NtakSubCategory(
    NtakSubCategoryId.LAKE_BOAT_CRUISE,
    () => $t('Lake boat cruise'),
    NtakMainCategoryId.TOURIST_TRANSPORT_INFRASTRUCTURE,
    [],
  )

  static readonly RIVER_BOAT_CRUISE = new NtakSubCategory(
    NtakSubCategoryId.RIVER_BOAT_CRUISE,
    () => $t('River boat cruise'),
    NtakMainCategoryId.TOURIST_TRANSPORT_INFRASTRUCTURE,
    [],
  )

  static readonly HOP_ON_HOP_OFF_PROGRAM = new NtakSubCategory(
    NtakSubCategoryId.HOP_ON_HOP_OFF_PROGRAM,
    () => $t('Hop-on hop-off program'),
    NtakMainCategoryId.TOURIST_TRANSPORT_INFRASTRUCTURE,
    [],
  )

  static readonly ADVENTURE_PARK_PROGRAM = new NtakSubCategory(
    NtakSubCategoryId.ADVENTURE_PARK_PROGRAM,
    () => $t('Adventure park program'),
    NtakMainCategoryId.ADVENTURE_PARK,
    [],
  )

  static readonly EXPERIENCE_CENTER_PROGRAM = new NtakSubCategory(
    NtakSubCategoryId.EXPERIENCE_CENTER_PROGRAM,
    () => $t('Experience center program'),
    NtakMainCategoryId.ADVENTURE_PARK,
    [],
  )

  static readonly ZOO_PROGRAM = new NtakSubCategory(
    NtakSubCategoryId.ZOO_PROGRAM,
    () => $t('Zoo program'),
    NtakMainCategoryId.ZOO,
    [],
  )

  static readonly WILDLIFE_PARK_PROGRAM = new NtakSubCategory(
    NtakSubCategoryId.WILDLIFE_PARK_PROGRAM,
    () => $t('Wildlife park program'),
    NtakMainCategoryId.ZOO,
    [],
  )

  static readonly AMUSEMENT_PARK_PROGRAM = new NtakSubCategory(
    NtakSubCategoryId.AMUSEMENT_PARK_PROGRAM,
    () => $t('Amusement park program'),
    NtakMainCategoryId.AMUSEMENT_PARK,
    [],
  )

  static readonly NATIONAL_PARK_VISIT = new NtakSubCategory(
    NtakSubCategoryId.NATIONAL_PARK_VISIT,
    () => $t('National park visit'),
    NtakMainCategoryId.PROTECTED_NATURAL_AREA,
    [],
  )

  static readonly HIKING_EXCURSIONS = new NtakSubCategory(
    NtakSubCategoryId.HIKING_EXCURSIONS,
    () => $t('Hiking / excursions'),
    NtakMainCategoryId.PROTECTED_NATURAL_AREA,
    [],
  )

  static readonly CULTURAL_EVENT = new NtakSubCategory(
    NtakSubCategoryId.CULTURAL_EVENT,
    () => $t('Cultural event'),
    NtakMainCategoryId.MUSIC_AND_DANCE_EVENT,
    [],
  )

  static readonly CONCERT = new NtakSubCategory(
    NtakSubCategoryId.CONCERT,
    () => $t('Concert'),
    NtakMainCategoryId.MUSIC_AND_DANCE_EVENT,
    [],
  )

  static readonly FESTIVAL = new NtakSubCategory(
    NtakSubCategoryId.FESTIVAL,
    () => $t('Festival'),
    NtakMainCategoryId.MUSIC_AND_DANCE_EVENT,
    [],
  )

  static readonly BREAKFAST = new NtakSubCategory(
    NtakSubCategoryId.BREAKFAST,
    () => $t('Breakfast'),
    NtakMainCategoryId.FOOD,
    [SegmentId.BREAKFAST],
  )

  static readonly SANDWICH = new NtakSubCategory(
    NtakSubCategoryId.SANDWICH,
    () => $t('Sandwich'),
    NtakMainCategoryId.FOOD,
    [],
  )

  static readonly STARTER = new NtakSubCategory(
    NtakSubCategoryId.STARTER,
    () => $t('Starter'),
    NtakMainCategoryId.FOOD,
    [],
  )

  static readonly SOUP = new NtakSubCategory(
    NtakSubCategoryId.SOUP,
    () => $t('Soup'),
    NtakMainCategoryId.FOOD,
    [],
  )

  static readonly MAIN_COURSE = new NtakSubCategory(
    NtakSubCategoryId.MAIN_COURSE,
    () => $t('Main course'),
    NtakMainCategoryId.FOOD,
    [],
  )

  static readonly SIDE_DISH = new NtakSubCategory(
    NtakSubCategoryId.SIDE_DISH,
    () => $t('Side dish'),
    NtakMainCategoryId.FOOD,
    [],
  )

  static readonly PICKLES_SALAD = new NtakSubCategory(
    NtakSubCategoryId.PICKLES_SALAD,
    () => $t('Pickles / salad'),
    NtakMainCategoryId.FOOD,
    [],
  )

  static readonly TASTING_PORTION = new NtakSubCategory(
    NtakSubCategoryId.TASTING_PORTION,
    () => $t('Tasting portion'),
    NtakMainCategoryId.FOOD,
    [],
  )

  static readonly BAKERY_PRODUCTS = new NtakSubCategory(
    NtakSubCategoryId.BAKERY_PRODUCTS,
    () => $t('Bakery products'),
    NtakMainCategoryId.FOOD,
    [],
  )

  static readonly DESSERT = new NtakSubCategory(
    NtakSubCategoryId.DESSERT,
    () => $t('Dessert'),
    NtakMainCategoryId.FOOD,
    [],
  )

  static readonly SNACK = new NtakSubCategory(
    NtakSubCategoryId.SNACK,
    () => $t('Snack'),
    NtakMainCategoryId.FOOD,
    [SegmentId.MINIBAR_MEALS],
  )

  static readonly MAIN_COURSE_WITH_SIDE_DISH = new NtakSubCategory(
    NtakSubCategoryId.MAIN_COURSE_WITH_SIDE_DISH,
    () => $t('Main course with side dish'),
    NtakMainCategoryId.FOOD,
    [],
  )

  static readonly MEAL_PACKAGE = new NtakSubCategory(
    NtakSubCategoryId.MEAL_PACKAGE,
    () => $t('Meal package'),
    NtakMainCategoryId.FOOD,
    [
      SegmentId.HALF_BOARD,
      SegmentId.FULL_BOARD,
      SegmentId.BUFFET,
      SegmentId.CATERING,
      SegmentId.HALF_BOARD_PACKAGE,
      SegmentId.FULL_BOARD_PACKAGE,
      SegmentId.CONFERENCE_FOOD,
    ],
  )

  static readonly WATER_LOCALLY_PREPARED = new NtakSubCategory(
    NtakSubCategoryId.WATER_LOCALLY_PREPARED,
    () => $t('Water (locally prepared)'),
    NtakMainCategoryId.SOFT_DRINKS_LOCALLY_PREPARED,
    [],
  )

  static readonly LEMONADE_SYRUP_FRESH_JUICE = new NtakSubCategory(
    NtakSubCategoryId.LEMONADE_SYRUP_FRESH_JUICE,
    () => $t('Lemonade / syrup / fresh juice'),
    NtakMainCategoryId.SOFT_DRINKS_LOCALLY_PREPARED,
    [],
  )

  static readonly NON_ALCOHOLIC_COCKTAIL = new NtakSubCategory(
    NtakSubCategoryId.NON_ALCOHOLIC_COCKTAIL,
    () => $t('Non-alcoholic cocktail'),
    NtakMainCategoryId.SOFT_DRINKS_LOCALLY_PREPARED,
    [],
  )

  static readonly TEA_HOT_CHOCOLATE_MILK_DRINKS = new NtakSubCategory(
    NtakSubCategoryId.TEA_HOT_CHOCOLATE_MILK_DRINKS,
    () => $t('Tea / hot chocolate / milk drinks'),
    NtakMainCategoryId.SOFT_DRINKS_LOCALLY_PREPARED,
    [],
  )

  static readonly SOFT_DRINK_LOCALLY_PREPARED_BEVERAGE_PACKAGE = new NtakSubCategory(
    NtakSubCategoryId.SOFT_DRINK_LOCALLY_PREPARED_BEVERAGE_PACKAGE,
    () => $t('Non-alcoholic beverage package (locally prepared)'),
    NtakMainCategoryId.SOFT_DRINKS_LOCALLY_PREPARED,
    [SegmentId.NONALCOHOLIC_DRINKS_PACKAGE],
  )

  static readonly WATER_NOT_LOCALLY_PREPARED = new NtakSubCategory(
    NtakSubCategoryId.WATER_NOT_LOCALLY_PREPARED,
    () => $t('Water (not locally prepared)'),
    NtakMainCategoryId.SOFT_DRINKS_NOT_LOCALLY_PREPARED,
    [],
  )

  static readonly FRUIT_DRINK = new NtakSubCategory(
    NtakSubCategoryId.FRUIT_DRINK,
    () => $t('Fruit drink'),
    NtakMainCategoryId.SOFT_DRINKS_NOT_LOCALLY_PREPARED,
    [],
  )

  static readonly CARBONATED_DRINK = new NtakSubCategory(
    NtakSubCategoryId.CARBONATED_DRINK,
    () => $t('Carbonated drink'),
    NtakMainCategoryId.SOFT_DRINKS_NOT_LOCALLY_PREPARED,
    [],
  )

  static readonly NON_CARBONATED_DRINK = new NtakSubCategory(
    NtakSubCategoryId.NON_CARBONATED_DRINK,
    () => $t('Non-carbonated drink'),
    NtakMainCategoryId.SOFT_DRINKS_NOT_LOCALLY_PREPARED,
    [],
  )

  static readonly COCKTAIL_MIXED_DRINK = new NtakSubCategory(
    NtakSubCategoryId.COCKTAIL_MIXED_DRINK,
    () => $t('Cocktail / mixed drink'),
    NtakMainCategoryId.ALCOHOLIC_BEVERAGES,
    [],
  )

  static readonly LIQUEUR = new NtakSubCategory(
    NtakSubCategoryId.LIQUEUR,
    () => $t('Liqueur'),
    NtakMainCategoryId.ALCOHOLIC_BEVERAGES,
    [],
  )

  static readonly SPIRIT = new NtakSubCategory(
    NtakSubCategoryId.SPIRIT,
    () => $t('Spirit'),
    NtakMainCategoryId.ALCOHOLIC_BEVERAGES,
    [],
  )

  static readonly BEER = new NtakSubCategory(
    NtakSubCategoryId.BEER,
    () => $t('Beer'),
    NtakMainCategoryId.ALCOHOLIC_BEVERAGES,
    [],
  )

  static readonly WINE = new NtakSubCategory(
    NtakSubCategoryId.WINE,
    () => $t('Wine'),
    NtakMainCategoryId.ALCOHOLIC_BEVERAGES,
    [],
  )

  static readonly SPARKLING_WINE = new NtakSubCategory(
    NtakSubCategoryId.SPARKLING_WINE,
    () => $t('Sparkling wine'),
    NtakMainCategoryId.ALCOHOLIC_BEVERAGES,
    [],
  )

  static readonly ALCOHOLIC_BEVERAGE_PACKAGE = new NtakSubCategory(
    NtakSubCategoryId.ALCOHOLIC_BEVERAGE_PACKAGE,
    () => $t('Alcoholic beverage package'),
    NtakMainCategoryId.ALCOHOLIC_BEVERAGES,
    [SegmentId.ALCOHOLIC_DRINKS_PACKAGE],
  )

  static readonly OTHER = new NtakSubCategory(
    NtakSubCategoryId.OTHER,
    () => $t('Other'),
    NtakMainCategoryId.OTHER,
    [
      SegmentId.OTHER,
      SegmentId.RETAIL_SALES,
      SegmentId.PARKING,
      SegmentId.OTHER_FEES,
      SegmentId.WARE,
      SegmentId.DAMAGE,
      SegmentId.CANCELLATION_FEES,
      SegmentId.CONFERENCE,
      SegmentId.INVENTORY,
      SegmentId.STAFF,
      SegmentId.FIXES,
      SegmentId.RETURNABLE_BOTTLE_FEES,
      SegmentId.SINGLE_PURPOSE_COUPON,
      SegmentId.MULTI_PURPOSE_COUPON,
      SegmentId.REUSABLE_CUP,
      SegmentId.OWNER,
    ],
  )

  static readonly SERVICE_CHARGE = new NtakSubCategory(
    NtakSubCategoryId.SERVICE_CHARGE,
    () => $t('Service charge'),
    NtakMainCategoryId.OTHER,
    [],
  )

  static readonly TIP = new NtakSubCategory(
    NtakSubCategoryId.TIP,
    () => $t('Tip'),
    NtakMainCategoryId.OTHER,
    [],
  )

  static readonly OTHER_HOSPITALITY_SERVICES = new NtakSubCategory(
    NtakSubCategoryId.OTHER_HOSPITALITY_SERVICES,
    () => $t('Other hospitality services'),
    NtakMainCategoryId.OTHER,
    [
      SegmentId.INTERNET,
      SegmentId.LEASE,
      SegmentId.LEASE_SPACES,
      SegmentId.SERVICES,
      SegmentId.SPORT,
      SegmentId.SPORTS_GROUND,
      SegmentId.PHONE,
      SegmentId.TRANSFER,
      SegmentId.HOUSEKEEPING,
      SegmentId.GAMING_CLUB,
      SegmentId.LAUNDRY,
      SegmentId.COFFEE_BREAK,
      SegmentId.EV_CHARGING_STATION,
    ],
  )

  static readonly CAVE_VISIT = new NtakSubCategory(
    NtakSubCategoryId.CAVE_VISIT,
    () => $t('Cave visit'),
    NtakMainCategoryId.PROTECTED_NATURAL_AREA,
    [],
  )

  static readonly GUIDED_TOUR_PROTECTED_NATURAL_AREA = new NtakSubCategory(
    NtakSubCategoryId.GUIDED_TOUR_PROTECTED_NATURAL_AREA,
    () => $t('Guided tour (protected natural area)'),
    NtakMainCategoryId.PROTECTED_NATURAL_AREA,
    [],
  )

  static readonly EDUCATIONAL_PROGRAM_PROTECTED_NATURAL_AREA = new NtakSubCategory(
    NtakSubCategoryId.EDUCATIONAL_PROGRAM_PROTECTED_NATURAL_AREA,
    () => $t('Educational program (protected natural area)'),
    NtakMainCategoryId.PROTECTED_NATURAL_AREA,
    [],
  )

  static readonly PARK_VISIT = new NtakSubCategory(
    NtakSubCategoryId.PARK_VISIT,
    () => $t('Park visit'),
    NtakMainCategoryId.PROTECTED_NATURAL_AREA,
    [],
  )

  static readonly THEMATIC_VISITOR_CENTRE_VISIT = new NtakSubCategory(
    NtakSubCategoryId.THEMATIC_VISITOR_CENTRE_VISIT,
    () => $t('Thematic visitor centre visit'),
    NtakMainCategoryId.PROTECTED_NATURAL_AREA,
    [],
  )

  static readonly FOOD_OTHER = new NtakSubCategory(
    NtakSubCategoryId.FOOD_OTHER,
    () => $t('Other food'),
    NtakMainCategoryId.FOOD,
    [SegmentId.MEALS],
  )

  static readonly COFFEE = new NtakSubCategory(
    NtakSubCategoryId.COFFEE,
    () => $t('Coffee'),
    NtakMainCategoryId.SOFT_DRINKS_LOCALLY_PREPARED,
    [],
  )

  static readonly SOFT_DRINK_NOT_LOCALLY_PREPARED_BEVERAGE_PACKAGE = new NtakSubCategory(
    NtakSubCategoryId.SOFT_DRINK_NOT_LOCALLY_PREPARED_BEVERAGE_PACKAGE,
    () => $t('Non-alcoholic beverage package (not locally prepared)'),
    NtakMainCategoryId.SOFT_DRINKS_NOT_LOCALLY_PREPARED,
    [],
  )

  private constructor(
    public readonly id: NtakSubCategoryId,
    public readonly name: () => string,
    public readonly mainCategoryId: NtakMainCategoryId,
    public readonly segmentIds: SegmentId[],
  ) {
    super(id)
  }

  /**
   * The subcategory a folio item gets from its segment alone. Returns null for segments that mix
   * several categories (minibar, drinks, packages) or that carry no NTAK subcategory at all.
   */
  static bySegment(segmentId: SegmentId): NtakSubCategory | null {
    return (
      NtakSubCategory.all().find((subCategory) => subCategory.segmentIds.includes(segmentId)) ??
      null
    )
  }

  static forMainCategory(mainCategoryId: NtakMainCategoryId): NtakSubCategory[] {
    return NtakSubCategory.all().filter(
      (subCategory) => subCategory.mainCategoryId === mainCategoryId,
    )
  }
}
